export const environment = {
  production: false,
  apiUrl: 'https://dev.perronstore.com/api',
  imagesUrl: 'https://dev.perronstore.com/images/',
  siteUrl: 'http://localhost:4200',
  passportClientId: '1',
  passportClientSecret: 'vjdzQKrSxAt5SQsNM3ZGbp6g539Rsjn3Ok61Vhfq',
  // Pasarela de pago. Pasarela · 5: 'onvo' contra el entorno de PRUEBAS (la key
  // de abajo es la PUBLISHABLE de TEST — pública, va al bundle; la secret vive
  // solo en el backend, ONVO_SECRET_KEY). Producción (environment.ts) sigue en
  // 'stub' hasta validar el E2E.
  payments: {
    provider: 'onvo' as 'stub' | 'onvo',
    onvoPublishableKey:
      'onvo_test_publishable_key_r4_G8kxjbA4ksV4inw3zykjq_GPjnf7gTLfdnR8ufC6nQBt150ee62xVe6y2hwwKmWZOm8F7faFvXIlA2VJUxA',
  },
  // Blog (B58 del spec del blog): encendido en desarrollo, contra la API dev de
  // arriba (W5: sin mocks). En producción (`environment.ts`) va a `false`. Para
  // la API local de Laragon, `--configuration local` (environment.local.ts).
  blogEnabled: true,
};
